import axios from 'index/axios'

/**
 * 创建申诉批次
 */
export const createAppealBatch = data => axios.post('/Appeal/batch/create', data, { loading: 'createBatch' })

/**
 * 上传申诉凭证
 */
export const uploadAppealEvidence = file => {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post('/Appeal/upload/image', formData, {
        loading: 'upload',
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then(({ data = {} }) => data.data || {})
}

/**
 * 获取批次准备信息
 */
export const getAppealBatchPrepare = answerKeys => axios.post('/Appeal/batch/prepare', answerKeys, { loading: 'prepare' }).then(({ data = {} }) => data.data || [])
